/**
 * DIEUKYDIEU.TV - AUDIO PLAYER UI CONTROLS, MODAL & SHORTCUTS
 */

import { currentAudioIndex, isRemainingTimeMode, setCurrentAudioIndex } from './player-state.js';
import { updatePlayState, updateSliderTrack } from './player-dom.js';
import { formatTime, formatTimeRemaining, updateLyricsHighlight } from './player-lyrics.js';
import { closeOptionsMenu, closeSleepTimerModal, toggleMute, updateVolumeIcon } from './player-controls.js';
import { togglePlay, playNext, seekRelative, renderQueueList } from '../player.js';

export function openFullPlayer() {
    const fp = document.getElementById('full-player');
    const backdrop = document.getElementById('full-player-backdrop');
    if (!fp) return;

    fp.classList.add('show');
    document.body.classList.add('has-active-player');

    if (backdrop) {
        backdrop.classList.add('show');
    }

    renderQueueList();
}

export function closeFullPlayer() {
    const fp = document.getElementById('full-player');
    const backdrop = document.getElementById('full-player-backdrop');
    if (fp) {
        fp.classList.remove('show');
        fp.style.transform = '';
    }
    if (backdrop) {
        backdrop.classList.remove('show');
        backdrop.style.opacity = '';
    }
    closeOptionsMenu();
    closeSleepTimerModal();
}

export function closePlayer(e) {
    if (e) e.stopPropagation();
    const audioEl = document.getElementById('main-audio');
    const miniPlayer = document.getElementById('mini-player');
    if (audioEl) audioEl.pause();
    if (miniPlayer) miniPlayer.classList.remove('active');
    closeFullPlayer();
    document.body.classList.remove('has-active-player');
    document.documentElement.style.removeProperty('--player-height');
    updatePlayState(false);
    setCurrentAudioIndex(-1);
}

export function initSeekbar() {
    const slider = document.getElementById('fp-slider');
    const audioEl = document.getElementById('main-audio');
    if (!slider) return;

    slider.addEventListener('input', (e) => {
        const val = parseFloat(e.target.value);
        updateSliderTrack(val);
        if (audioEl && audioEl.duration) {
            const timeCur = document.getElementById('fp-time-current');
            if (timeCur) timeCur.innerText = formatTime((val / 100) * audioEl.duration);
        }
    });

    slider.addEventListener('change', (e) => {
        const val = parseFloat(e.target.value);
        if (audioEl && audioEl.duration) {
            audioEl.currentTime = (val / 100) * audioEl.duration;
        }
    });
}

export function initAudioElementEvents() {
    const audioEl = document.getElementById('main-audio');
    if (!audioEl) return;

    audioEl.addEventListener('timeupdate', () => {
        if (audioEl.duration) {
            const percent = (audioEl.currentTime / audioEl.duration) * 100;
            const fill = document.getElementById('mp-progress-fill');
            const slider = document.getElementById('fp-slider');
            const timeCur = document.getElementById('fp-time-current');
            const timeTot = document.getElementById('fp-time-total');

            if (fill) fill.style.width = `${percent}%`;
            if (slider && !slider.matches(':active')) {
                slider.value = percent;
                updateSliderTrack(percent);
            }
            if (timeCur) timeCur.innerText = formatTime(audioEl.currentTime);
            if (timeTot) {
                timeTot.innerText = isRemainingTimeMode 
                    ? formatTimeRemaining(audioEl.currentTime, audioEl.duration) 
                    : formatTime(audioEl.duration);
            }
            updateLyricsHighlight(audioEl.currentTime);
        }
    });

    audioEl.addEventListener('ended', () => {
        playNext(true);
    });
}

export function initKeyboardShortcuts() {
    window.addEventListener('keydown', (e) => {
        if (['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName) || document.activeElement?.isContentEditable) {
            return;
        }

        const fp = document.getElementById('full-player');
        const isFpOpen = fp && fp.classList.contains('show');
        const audioEl = document.getElementById('main-audio');

        if (e.code === 'Space') {
            if (currentAudioIndex !== -1 || isFpOpen) {
                e.preventDefault();
                togglePlay();
            }
        } else if (e.key === 'm' || e.key === 'M') {
            toggleMute();
        } else if (e.key === 'ArrowLeft' && isFpOpen) {
            e.preventDefault();
            seekRelative(-5);
        } else if (e.key === 'ArrowRight' && isFpOpen) {
            e.preventDefault();
            seekRelative(5);
        } else if (e.key === 'ArrowUp' && isFpOpen) {
            e.preventDefault();
            if (audioEl) {
                audioEl.volume = Math.min(1, Math.round((audioEl.volume + 0.05) * 100) / 100);
                const slider = document.getElementById('fp-vol-slider');
                if (slider) slider.value = audioEl.volume;
                updateVolumeIcon();
            }
        } else if (e.key === 'ArrowDown' && isFpOpen) {
            e.preventDefault();
            if (audioEl) {
                audioEl.volume = Math.max(0, Math.round((audioEl.volume - 0.05) * 100) / 100);
                const slider = document.getElementById('fp-vol-slider');
                if (slider) slider.value = audioEl.volume;
                updateVolumeIcon();
            }
        } else if (e.key === 'Escape' && isFpOpen) {
            closeFullPlayer();
        }
    });
}
